import { createAction, createAsyncActionTypes, SCOPE_DESTROYED } from '@mews/framework';
import { DESTROY_SCOPE } from '@mews-commander/utils';
import prefix from './prefix';
import { getSelectedEntityId } from './selectors';

// operations
export const ENTITY_ADDING_STARTED = prefix('ENTITY_ADDING_STARTED');
export const ENTITY_ADDING_STOPPED = prefix('ENTITY_ADDING_STOPPED');

export const ENTITY_EDITING_STARTED = prefix('ENTITY_EDITING_STARTED');
export const ENTITY_EDITING_STOPPED = prefix('ENTITY_EDITING_STOPPED');

export const ENTITY_DELETING_STARTED = prefix('ENTITY_DELETING_STARTED');
export const ENTITY_DELETING_STOPPED = prefix('ENTITY_DELETING_STOPPED');

// asyncs
const ADD_ENTITY = prefix('ADD_ENTITY');
export const [ADD_ENTITY_STARTED, ADD_ENTITY_SUCCEEDED, ADD_ENTITY_FAILED] = createAsyncActionTypes(ADD_ENTITY);

const EDIT_ENTITY = prefix('EDIT_ENTITY');
export const [EDIT_ENTITY_STARTED, EDIT_ENTITY_SUCCEEDED, EDIT_ENTITY_FAILED] = createAsyncActionTypes(EDIT_ENTITY);

const DELETE_ENTITY = prefix('DELETE_ENTITY');
export const [DELETE_ENTITY_STARTED, DELETE_ENTITY_SUCCEEDED, DELETE_ENTITY_FAILED] =
    createAsyncActionTypes(DELETE_ENTITY);

export const startEntityAdding = (scope: string) => createAction(ENTITY_ADDING_STARTED, undefined, { scope });
export const stopEntityAdding = (scope: string) => createAction(ENTITY_ADDING_STOPPED, undefined, { scope });

export const startEntityEditing = (selectedEntityId: string, scope: string) =>
    createAction(ENTITY_EDITING_STARTED, selectedEntityId, { scope });
export const stopEntityEditing = (scope: string) => createAction(ENTITY_EDITING_STOPPED, undefined, { scope });

export const startEntityDeleting = (selectedEntityId: string, scope: string) =>
    createAction(ENTITY_DELETING_STARTED, selectedEntityId, { scope });

export const stopEntityDeleting = (scope: string) => createAction(ENTITY_DELETING_STOPPED, undefined, { scope });

export const destroyEntityScope = (scope: string) => createAction(DESTROY_SCOPE, undefined, { scope });

export const createAddAction =
    (adder: $TSFixMe) =>
    (params: $TSFixMe, scope: $TSFixMe, { dispatchStopOnSuccess = true } = {}) =>
    (dispatch: $TSFixMe) => {
        const meta = { scope };
        dispatch(createAction(ADD_ENTITY_STARTED, undefined, meta));

        return dispatch(adder(params))
            .then(({ value }: $TSFixMe) => {
                if (dispatchStopOnSuccess) {
                    dispatch(stopEntityAdding(scope));
                }
                dispatch(createAction(ADD_ENTITY_SUCCEEDED, undefined, meta));
                return value;
            })
            .catch((err: $TSFixMe) => {
                dispatch(createAction(ADD_ENTITY_FAILED, undefined, meta));
                throw err;
            });
    };

export const createEditAction =
    (editer: $TSFixMe) =>
    (params: $TSFixMe, scope: $TSFixMe, { dispatchStopOnSuccess = true } = {}) =>
    (dispatch: $TSFixMe, getState: $TSFixMe) => {
        const meta = { scope };
        const id = getSelectedEntityId(getState(), meta);
        const entity = { ...params, id };

        dispatch(createAction(EDIT_ENTITY_STARTED, undefined, meta));

        return dispatch(editer(entity))
            .then(() => {
                if (dispatchStopOnSuccess) {
                    dispatch(stopEntityEditing(scope));
                }
                dispatch(createAction(EDIT_ENTITY_SUCCEEDED, entity, meta));
            })
            .catch((err: $TSFixMe) => {
                dispatch(createAction(EDIT_ENTITY_FAILED, undefined, meta));
                throw err;
            });
    };

export const createDeleteAction =
    (deleter: $TSFixMe) => (params: $TSFixMe, scope: $TSFixMe) => (dispatch: $TSFixMe, getState: $TSFixMe) => {
        const meta = { scope };
        const id = getSelectedEntityId(getState(), meta);
        const entity = { ...params, id };

        dispatch(createAction(DELETE_ENTITY_STARTED, undefined, meta));

        return dispatch(deleter(entity))
            .then(({ value }: $TSFixMe) => {
                dispatch(stopEntityDeleting(scope));
                dispatch(stopEntityEditing(scope));
                dispatch(createAction(DELETE_ENTITY_SUCCEEDED, entity, meta));
                return value;
            })
            .catch((err: $TSFixMe) => {
                dispatch(createAction(DELETE_ENTITY_FAILED, undefined, meta));
                throw err;
            });
    };

export const destroyScope = (scope: string) => createAction(SCOPE_DESTROYED, undefined, { scope });
